import useApiMutation from 'shared/hooks/use-api-mutation';
import useInfiniteQueryHelpers from 'shared/hooks/use-infinite-query-helpers';

export interface ApiSwitchProps {
  url: string;
  isChecked: boolean;
  multipart?: boolean;
  queryKey: any;
  field?: string;
  disabled?: boolean;
}

const useSwitchState = ({url, multipart, queryKey}: ApiSwitchProps) => {
  const {update} = useInfiniteQueryHelpers();

  const {mutate, isLoading} = useApiMutation({
    method: 'PATCH',
    url,
    errorTitle: 'Erro ao alterar status',
    successTitle: 'Atualização de status',
    successMessage: 'Status atualizado com sucesso',
    onSuccess: (data) => update(queryKey, data),
  });

  const handleRequest = (isChecked: boolean, field: string) => {
    if (multipart) {
      const formData = new FormData();
      formData.append(field, String(isChecked));
      return mutate(formData);
    }
    mutate({[field]: isChecked});
  };

  return {
    handleRequest,
    isLoading,
  };
};

export default useSwitchState;
